export { default } from "./src/background-video-container";

export type { UniformBackgroundVideoContainerProps } from "./src/background-video-container";
